import { render, staticRenderFns } from "./paymentResults.vue?vue&type=template&id=6bd500fe&scoped=true"
import script from "./paymentResults.vue?vue&type=script&lang=js"
export * from "./paymentResults.vue?vue&type=script&lang=js"
import style0 from "./paymentResults.vue?vue&type=style&index=0&id=6bd500fe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd500fe",
  null
  
)

export default component.exports